import type { Module } from '@pc/core';
import { lazyWithReload } from '@pc/ui';

const RewardsDashboardPage = lazyWithReload(() => import('./pages/RewardsDashboardPage'));
const CommissionsListPage = lazyWithReload(() => import('./pages/CommissionsListPage'));
const CreditLedgerPage = lazyWithReload(() => import('./pages/CreditLedgerPage'));
const RewardsDashboardWidget = lazyWithReload(
  () => import('./widgets/RewardsDashboardWidget'),
);

export const rewardsModule: Module = {
  id: 'rewards',
  name: 'Rewards',
  description:
    'Client wallets + referral program. Pay clients back in credit for purchases or referrals; track every cent in an audited ledger.',
  basePath: '/rewards',
  routes: [
    { path: '/', element: <RewardsDashboardPage /> },
    { path: '/commissions', element: <CommissionsListPage /> },
    { path: '/credits', element: <CreditLedgerPage /> },
  ],
  navItems: [{ label: 'Rewards', to: '/rewards', order: 35 }],
  dashboardWidgets: [
    {
      id: 'rewards-summary',
      span: 1,
      order: 35,
      render: RewardsDashboardWidget,
    },
  ],
};
